import { Session } from "next-auth";
import { z } from "zod";

import { getDeleter, getFetcher, getPoster } from "../../hooks/useFetcher";
import { decode } from "../../utils";

const FavouriteResponse = z.array(z.string());
type FavouriteResponse = z.infer<typeof FavouriteResponse>;

export const BookmarkArticlesKey = "/students/v2/me/bookmark/articles";

export async function getBookmarkArticles({
  session,
}: {
  session: Session | null;
}): Promise<string[]> {
  const fetcher = getFetcher<string[]>(
    { headers: { Authorization: "Bearer " + session?.accessToken } },
    ({ data }) => decode(FavouriteResponse.safeParse(data)),
  );
  return fetcher(BookmarkArticlesKey + "/ids");
}

export async function appendBookmarkArticle({
  id,
  session,
}: {
  id: string;
  session: Session | null;
}): Promise<void> {
  const req = getPoster<{ articleId: string }, void>(
    { headers: { Authorization: "Bearer " + session?.accessToken } },
    { articleId: id },
    undefined,
  );
  await req(BookmarkArticlesKey);
}

export async function deductBookmarkArticle({
  id,
  session,
}: {
  id: string;
  session: Session | null;
}): Promise<void> {
  const req = getDeleter<{ articleId: string }, void>(
    { headers: { Authorization: "Bearer " + session?.accessToken } },
    { articleId: id },
    undefined,
  );
  await req(BookmarkArticlesKey);
}
